<h1 class="title" data-ui-name="Multi Factor Authentication (MFA) Requirements" data-ui-component="tc-modal-mfa-requirements" data-testid="tc-modal-mfa-requirements-multi-factor-authentication-mfa-requirements">
    Multi-Factor Authentication (MFA) Requirements
</h1>
<p>
    You can configure MFA requirements for each role in the system. 
    If you enable MFA for a role, users with that role will be required to use MFA to log in unless they are exempted.
</p>
<p *ngIf="IS_MFA_DISABLED">
    <strong>MFA is currently disabled for the entire system.</strong>
</p>
<hr>
<div class="block" *ngFor="let role of u_role_types">
    <h2 class="subtitle" data-ui-name="Role name" data-ui-component="tc-modal-mfa-requirements" data-testid="tc-modal-mfa-requirements-role-name">
        <i class="fas fa-user"></i>&nbsp;
        {{role.name}}
    </h2>
    <p>
        {{role.description}}
    </p>
    <button class="button is-small" [class.is-info]="role.requires_mfa" (click)="toggleMfaRequired(role)" data-ui-name="Toggle Mfa Required" data-ui-component="tc-modal-mfa-requirements" data-testid="tc-modal-mfa-requirements-toggle-mfa-required">
        {{role.requires_mfa ? 'Disable' : 'Enable'}} MFA Requirement
    </button>
</div>
<div class="buttons">
    <button class="button is-info" (click)="saveMfaRequirements()" [disabled]="changedRoles.length === 0" data-ui-name="Save" data-ui-component="tc-modal-mfa-requirements" data-testid="tc-modal-mfa-requirements-save">
        Save
    </button>
    <button class="button" (click)="closeModal()" data-ui-name="Cancel" data-ui-component="tc-modal-mfa-requirements" data-testid="tc-modal-mfa-requirements-cancel">
        Cancel
    </button>
</div>